import { useAuthorization } from '@entities/authentication'
import { couponEntityQueries } from '@entities/coupon'
import { useSuspenseQuery } from '@tanstack/react-query'

export const useCouponHistoryQuery = () => {
  const { bearerToken } = useAuthorization()

  return useSuspenseQuery({ ...couponEntityQueries.couponHistory({ bearerToken }) })
}
